import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SubscriptionPlan  {
    _originalTypeClassName = "zAppDevManager.BO.SubscriptionPlan";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SubscriptionPlan.translate = translateService;
}
this.Id = null;
this.Name = null;
this.IsFree = false;
this.Price = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
IsFree:any;
Price:any;
Description:any;

static SerializeRow(row: any): any{let s = new Domain.SubscriptionPlan();
s.Id = Joove.Common.cast(row.get("Id"), "number");
s.Name = Joove.Common.cast(row.get("Name"), "string");
s.Description = Joove.Common.cast(row.get("Description"), "string");
s.IsFree = Joove.Common.cast(row.get("IsFree"), "boolean");
s.Price = Joove.Common.cast(row.get("IsFree"), "number");
return s;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}